import { z } from "zod";

export const siteDocumentationSchema = z.object({
	id: z.number().optional().nullable(),
	site_id: z.string().min(1, "Site is required"),
	category: z.string().min(1, "Category is required"),
	documentation_date: z.string().min(1, "Documentation date is required"),
	remarks: z.string().optional().nullable(),
	uploaded_checklist: z.number().optional().nullable(),
	total_checklist: z.number().optional().nullable(),
	completion_percentage: z.number().optional().nullable(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
	mir_count: z.number().optional().nullable(),
	site: z
		.object({
			id: z.string(),
			site_code: z.string(),
			description: z.string().optional().nullable(),
			location_name: z.string(),
		})
		.optional()
		.nullable(),
	creator: z
		.object({
			id: z.number().optional().nullable(),
			name: z.string().optional().nullable(),
			email: z.string().optional().nullable(),
		})
		.optional()
		.nullable(),
});

export type SiteDocumentation = z.infer<typeof siteDocumentationSchema>;
